"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var startsWith_1 = __importDefault(require("lodash/startsWith"));
var merge_1 = __importDefault(require("lodash/merge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var core_2 = require("@material-ui/core");
var KeyboardArrowLeft_1 = __importDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = __importDefault(require("@material-ui/icons/KeyboardArrowRight"));
var Event_1 = __importDefault(require("@material-ui/icons/Event"));
var moment_1 = __importDefault(require("moment"));
var pickers_1 = require("@material-ui/pickers");
var moment_2 = __importDefault(require("@date-io/moment"));
// Workaround typing problems in @material-ui/pickers@3.2.3
var AnyPropsKeyboardDatePicker = pickers_1.KeyboardDatePicker;
var MaterialDateControl = /** @class */ (function (_super) {
    __extends(MaterialDateControl, _super);
    function MaterialDateControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialDateControl.prototype.render = function () {
        var _a = this.props, description = _a.description, id = _a.id, errors = _a.errors, label = _a.label, uischema = _a.uischema, visible = _a.visible, enabled = _a.enabled, required = _a.required, path = _a.path, handleChange = _a.handleChange, data = _a.data, momentLocale = _a.momentLocale, config = _a.config;
        var defaultLabel = label;
        var cancelLabel = '%cancel';
        var clearLabel = '%clear';
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var inputProps = {};
        var localeDateTimeFormat = momentLocale
            ? "" + momentLocale.localeData().longDateFormat('L')
            : 'YYYY-MM-DD';
        var labelText;
        var labelCancel;
        var labelClear;
        if (core_1.isPlainLabel(label)) {
            labelText = label;
            labelCancel = 'Cancel';
            labelClear = 'Clear';
        }
        else {
            labelText = defaultLabel;
            labelCancel = startsWith_1.default(cancelLabel, '%') ? 'Cancel' : cancelLabel;
            labelClear = startsWith_1.default(clearLabel, '%') ? 'Clear' : clearLabel;
        }
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_2.default },
                react_1.default.createElement(AnyPropsKeyboardDatePicker, { id: id + '-input', label: core_1.computeLabel(labelText, required, appliedUiSchemaOptions.hideRequiredAsterisk), error: !isValid, fullWidth: !appliedUiSchemaOptions.trim, helperText: !isValid ? errors : showDescription ? description : ' ', InputLabelProps: { shrink: true }, value: data || null, onChange: function (datetime) {
                        return handleChange(path, datetime ? moment_1.default(datetime).format('YYYY-MM-DD') : '');
                    }, format: localeDateTimeFormat, clearable: true, disabled: !enabled, autoFocus: appliedUiSchemaOptions.focus, onFocus: this.onFocus, onBlur: this.onBlur, cancelLabel: labelCancel, clearLabel: labelClear, leftArrowIcon: react_1.default.createElement(KeyboardArrowLeft_1.default, null), rightArrowIcon: react_1.default.createElement(KeyboardArrowRight_1.default, null), keyboardIcon: react_1.default.createElement(Event_1.default, null), InputProps: inputProps }))));
    };
    return MaterialDateControl;
}(react_2.Control));
exports.MaterialDateControl = MaterialDateControl;
exports.materialDateControlTester = core_1.rankWith(4, core_1.isDateControl);
exports.default = react_2.withJsonFormsControlProps(MaterialDateControl);
//# sourceMappingURL=MaterialDateControl.js.map